export default "__VITE_ASSET__BdOcnipZ__"